module.exports = ".btn-right {\n    float: right;\n}\n.download-btn{\n    margin-top: 4%;\n}"